import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn px-1 py-0 ms-1 btn-outline-primary icon-size",
  "data-bs-toggle": "dropdown",
  id: "ReferralRow__Actions${id}"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h icon-size" })
], -1 /* HOISTED */)
const _hoisted_9 = {
  class: "dropdown-menu",
  "aria-labelledby": "ReferralRow__Actions${id}"
}
const _hoisted_10 = {
  key: 1,
  colspan: "4"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download animated slow flash infinite mr-1" }),
  /*#__PURE__*/_createElementVNode("b", null, "Download In Progress...")
], -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  colspan: "4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print animated slow flash infinite mr-1" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("b", null, "Printing In Progress...")
], -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 3,
  colspan: "4"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", null, "Reassigning In Progress", -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 4,
  colspan: "4"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", null, "Viewing Task Details", -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 5,
  colspan: "4"
}
const _hoisted_23 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_24 = ["colspan"]
const _hoisted_25 = {
  key: 0,
  class: "px-5 py-2 d-flex flex-column text-center text-primary"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exchange-alt fa-7x animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Save In Progress...")
], -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "d-flex flex-column align-items-center p-5"
}
const _hoisted_30 = {
  key: 0,
  class: "shimmer-loading"
}
const _hoisted_31 = {
  key: 0,
  class: "text-center pt-3"
}
const _hoisted_32 = {
  key: 1,
  class: "edit-row"
}
const _hoisted_33 = ["colspan"]
const _hoisted_34 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Saving...")
], -1 /* HOISTED */)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _component_VisitDetailsHomeHealth = _resolveComponent("VisitDetailsHomeHealth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`${_ctx.isDeleteRequested || _ctx.reassignInProgress || _ctx.viewingTaskDetails ? 'edit-row' : ''}`)
    }, [
      _createElementVNode("td", null, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTaskClick(_ctx.task))),
          class: _normalizeClass(`text-${_ctx.taskStatusNameColor(_ctx.task.Status)}`)
        }, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.task.TaskName
          }, null, 8 /* PROPS */, ["text"])
        ], 2 /* CLASS */)
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("span", {
          class: _normalizeClass(`task-status badge badge-pill badge-outline-${_ctx.taskStatusNameColor(_ctx.task.Status)} text-align-left`)
        }, _toDisplayString(_ctx.task.Status), 3 /* TEXT, CLASS */)
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.formatDate(_ctx.task.StartDate, 'MM/DD/YYYY')
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.formatDate(_ctx.task.EndDate, 'MM/DD/YYYY')
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleEmployeeNameClick(_ctx.task)))
        }, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.getEmployeeName(_ctx.task),
            exceptionMessage: "Unassigned"
          }, null, 8 /* PROPS */, ["text"])
        ])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, { text: "" })
      ]),
      (
                !_ctx.printingInProgress &&
                !_ctx.downloadInProgress &&
                !_ctx.isDeleteRequested &&
                !_ctx.reassignInProgress &&
                !_ctx.viewingTaskDetails
            )
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            _createElementVNode("button", {
              class: "btn table-btn btn-outline-info",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadVisit()))
            }, _hoisted_3),
            _createElementVNode("button", {
              class: "btn table-btn btn-outline-info",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.printVisit()))
            }, _hoisted_5),
            (!_ctx.cantDeleteOrReassignTask)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn table-btn btn-outline-danger",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.requestDeleteTask()))
                }, _hoisted_7))
              : _createCommentVNode("v-if", true),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              (!_ctx.cantDeleteOrReassignTask)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "dropdown-item",
                    href: "javascript:void(0);",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleReassignVisit()))
                  }, " Reassign "))
                : _createCommentVNode("v-if", true),
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:void(0);",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleViewTaskDetails()))
              }, " Task Details ")
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.downloadInProgress)
        ? (_openBlock(), _createElementBlock("td", _hoisted_10, _hoisted_12))
        : _createCommentVNode("v-if", true),
      (_ctx.printingInProgress)
        ? (_openBlock(), _createElementBlock("td", _hoisted_13, _hoisted_15))
        : _createCommentVNode("v-if", true),
      (_ctx.reassignInProgress)
        ? (_openBlock(), _createElementBlock("td", _hoisted_16, _hoisted_18))
        : _createCommentVNode("v-if", true),
      (_ctx.viewingTaskDetails)
        ? (_openBlock(), _createElementBlock("td", _hoisted_19, _hoisted_21))
        : _createCommentVNode("v-if", true),
      (_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "delete",
              name: "Task",
              isInProgress: _ctx.isDeleteInProgress,
              ok: _ctx.deleteTask,
              cancel: _ctx.cancelDeleteTask
            }, null, 8 /* PROPS */, ["isInProgress", "ok", "cancel"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (_ctx.reassignInProgress)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3 edit"
          }, [
            _createVNode(_component_FormSection, {
              fullHeight: false,
              applicationId: _ctx.application
            }, {
              content: _withCtx(() => [
                (_ctx.isSaving)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_25, _hoisted_28))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (_ctx.loadingUsers)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                        : (_openBlock(), _createBlock(_component_TypeaheadInput, {
                            key: 1,
                            class: "w-30",
                            getData: _ctx.employeeListFilter,
                            value: _ctx.scheduleEmployee,
                            onValueChanged: _ctx.changescheduleEmployee,
                            placeholder: "Type to Select User",
                            "show-all-by-default": true,
                            "open-on-focus": true,
                            "dropdown-menu-class": "custom-menu"
                          }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"]))
                    ]))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["applicationId"]),
            (!_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-md",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.reassignVisit()))
                  }, "Save"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-md ms-2",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleCancelReassign()))
                  }, " Cancel ")
                ]))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_24)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.viewingTaskDetails)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3 edit"
          }, [
            (_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37))
              : (_openBlock(), _createBlock(_component_VisitDetailsHomeHealth, {
                  key: 1,
                  visitDetails: _ctx.task,
                  isSaving: _ctx.isSaving,
                  "onUpdate:isSaving": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isSaving) = $event)),
                  reassign: _ctx.reassignVisit,
                  cancel: _ctx.cancelViewTaskDetails,
                  ok: _ctx.savedTaskDetails
                }, null, 8 /* PROPS */, ["visitDetails", "isSaving", "reassign", "cancel", "ok"]))
          ], 8 /* PROPS */, _hoisted_33)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}